/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateReleaseRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'
import {CreateOrUpdateReleaseResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'


export const createOrUpdateRelease = (request: CreateOrUpdateReleaseRequest, options?: CashRequestOptions) => post<CreateOrUpdateReleaseRequest, CreateOrUpdateReleaseResponse>("/2.0/cash/create-or-update-release", request, {...options, rejectOnError: true })